import MotionWrapper from '../../layouts/MotionWrapper';
import styles from './style.module.scss';
import Entrance from '../../layouts/Entrance';
import { TypographyLogo } from '../../assets/icons';
import Button from '../../components/Button';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useDispatch } from '../../store/store';
import { setSignUpStep } from '../../store/signUp/slice';

function Welcome() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setSignUpStep('registerEmail'));
  }, []);

  return (
    <Entrance>
      <MotionWrapper className={styles.wrapper}>
        <TypographyLogo width={280} height={70} />
        <span className={styles.slogan}>
          Merit experts are all you need for your business.
        </span>
        <div className={styles.actions}>
          <Button
            type='Primary'
            text='Sign up'
            className={styles.actions_btn}
            onClick={() => navigate('/signup')}
          />
          <Button
            text='Sign in'
            type='Outline-Primary'
            className={styles.actions_btn}
            onClick={() => navigate('/signin')}
          />
        </div>
      </MotionWrapper>
    </Entrance>
  )
};

export default Welcome;
